// This file is not currently in use

import React, { useState, useEffect } from "react";
import { BuilderComponent } from "@builder.io/react";
import { builderClient } from "../../utils/builder";
import styles from "./ContentTilePLP.module.scss";

export const ContentTilePLP = ({ model }) => {
  const [builderContentJson, setBuilderContentJson] = useState(null);
  useEffect(() => {
    builderClient.get({ model }).promise().then(setBuilderContentJson);
  }, [model]);

  if (model && builderContentJson) {
    return (
      <li className={`ais-Hits-item ${styles.content_tile} ${model} content-tile-phone content_tile`}>
        <BuilderComponent model={model} content={builderContentJson} />
      </li>
    );
  }
};

export default ContentTilePLP;
